/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.reporting.api.metadata.rpc.ReportingApiMetadataRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const ExternalOptionsPropertyReferenceTypename = 'com.hubspot.reporting.api.core.dataset.references.ExternalOptionsPropertyReference';
export const InteractionTypePropertyReferenceTypename = 'com.hubspot.reporting.api.core.dataset.references.InteractionTypePropertyReference';
export const StandardPropertyReferenceTypename = 'com.hubspot.reporting.api.core.dataset.references.StandardPropertyReference';
export const getPropertyMetadataRpc = {
  serviceName: 'com.hubspot.reporting.api.metadata.rpc.ReportingApiMetadataRpc',
  rpcName: 'getPropertyMetadata',
  auth: 'app',
  fingerprint: 'JD-wC3amcM-rlH9mMcpnkpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPropertyMetadataGroupsRpc = {
  serviceName: 'com.hubspot.reporting.api.metadata.rpc.ReportingApiMetadataRpc',
  rpcName: 'getPropertyMetadataGroups',
  auth: 'app',
  fingerprint: 'JD-wC3amcM8uWjVCrvHrkZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getVisiblePropertiesRpc = {
  serviceName: 'com.hubspot.reporting.api.metadata.rpc.ReportingApiMetadataRpc',
  rpcName: 'getVisibleProperties',
  auth: 'app',
  fingerprint: 'AkfF0ZJkf_ICR8XRkmR_8pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};